import React from 'react'
import EditIcon from "../../../assets/icons/edit.svg";
import SaveIcon from "../../../assets/icons/save.svg";
import CrossIcon from "../../../assets/icons/cross.svg";

const ActionButtons = ({ isEditing, onSave, onCancel, onEdit }) => {

  return isEditing ? (
    <>
      <button type="button" onClick={onSave} className="button-icontrigger save flex-align-self m-r-auto">
        <span><SaveIcon /></span>
      </button>
      <button
        type="button"
        onClick={onCancel}
        className="button-icontrigger modal-closetrigger cross flex-align-self"
      >
        <span className="icon"><CrossIcon /></span>
      </button>
    </>
  ) : (
    <button type="button" className="button-icontrigger noborder" onClick={onEdit}>
      <span className="icon"><EditIcon /></span>
    </button>
  );
};

export default ActionButtons